// store/configSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { makeApiRequest } from '../../shared/api';

export const fetchConfig = createAsyncThunk(
  'app/fetchConfig',
  async(_, { rejectWithValue }) => {
    try {
      const response = await makeApiRequest('GET', 'app/config');
      const { dashboard, reports, facebot_count } = response;
      if (!dashboard?.dashboardID || !dashboard?.url) {
        return rejectWithValue('Invalid dashboard configuration from API.');
      }

      return {
        dashboardId: dashboard.dashboardID,
        dashboardUrl: dashboard.url,
        reports: reports || [],
        facebot_count: facebot_count
      };
    } catch (error) {
      return rejectWithValue('Error fetching dashboard config.');
    }
  }
);

const configSlice = createSlice({
  name: 'config',
  initialState: {
    dashboardId: null,
    dashboardUrl: null,
    reports: [],
    facebot_count:null,
    loading: false,
    error: null,
  },
  reducers: {
    clearConfig: (state) => {
      state.dashboardId = null;
      state.dashboardUrl = null;
      state.reports = [];
      state.facebot_count = null;
      state.error = null;
      state.loading = false;
    },
    setActiveDashboard: (state, action) => {
      const { dashboardId, dashboardUrl } = action.payload;
      state.dashboardId = dashboardId;
      state.dashboardUrl = dashboardUrl;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.dashboardId = action.payload.dashboardId;
        state.dashboardUrl = action.payload.dashboardUrl;
        state.reports = action.payload.reports;
        state.facebot_count = action.payload.facebot_count;
        state.loading = false;
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearConfig, setActiveDashboard } = configSlice.actions;

export default configSlice.reducer;

// selectors
export const selectConfig = (state) => state.config;
export const selectReports = (state) => state.config.reports;
export const selectFacebotCount = (state) => state.config.facebot_count;
